<!-- 滚轮横向滚动组件 -->
<template>
  <div class="horwheel-img">
    <div id="brave">
      <!-- 底图部分 -->
      <img id="brave-long-img" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/bg2.jpg" />
      <video src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/brave/jiuren.mp4" autoplay muted loop preload="auto" class="video-bg video-bg1"></video>
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/video-mask3.png" class="video-bg1-mask" />
      <!-- 天空云层部分 -->
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="861" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5.png" class="absolute cloud-ani" alt="static" data-wd="800" data-left="1551" data-top="80" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud4.png" class="absolute cloud-ani" alt="static" data-wd="901" data-left="13800" data-top="-20" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud6.png" class="absolute cloud-ani" alt="static" data-wd="600" data-left="15200" data-top="-20" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/cloud5.png" class="absolute cloud-ani" alt="static" data-wd="800" data-left="15900" data-top="-30" />
      <!-- 前言 -->
      <div data-alt="speed" class="absolute left-0" data-wd="557" data-left="119" data-top="157">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/title.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="495" data-left="974" data-top="144">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk1_1.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0 opacity-0" data-wd="180" data-left="873" data-top="127" data-active="ani3" data-left-percentage="0.6" id="brave-talk1">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/brave.gif" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="665" data-left="1369">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person1.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="664" data-left="1990" data-top="501">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk9.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="302" data-left="1841" data-top="149" @click="showModal('cms')">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/play-mp4_1.png" class="width-100" />
      </div>

      <!-- <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/circle.png" class="absolute" alt="static" data-wd="423" data-left="3642" data-top="443" /> -->

      <div data-alt="speed" class="absolute left-0" data-wd="1066" data-left="4062" id="brave-talk3" data-left-percentage="0.7">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person2.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="1015" data-left="4098" data-top="456">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/chandou.png" class="width-100 ani-shake" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.7" data-wd="521" data-left="3772" data-top="336">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk2.png" class="width-100 opacity-0" />
      </div>

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/gif2/xdt.gif" class="absolute" alt="static" data-wd="932" data-left="5037" data-top="467" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person3.png" class="absolute" alt="static" data-wd="1341" data-left="5517" data-top="426" />

      <div data-alt="speed" class="absolute left-0" data-wd="416" data-left="5933" data-top="238">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk3_1.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="531" data-left="7059" data-top="621">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk4.png" class="width-100" />
      </div>

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk5.png" data-active="ani1" data-left-percentage="0.8" class="absolute  opacity-0" alt="static" data-wd="554" data-left="7186" data-top="165" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/4/person8.png" class="absolute" alt="static" data-wd="1195" data-left="7560" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/gif2/xt.gif" class="absolute" alt="static" data-wd="239" data-left="7793" data-top="497" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person4.png" class="absolute" alt="static" data-wd="623" data-left="8834" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/q1.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="304" data-left="8582" data-top="879" @click="changeAnswer1()" :class="{ ani1: question }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/q2.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="380" data-left="8953" data-top="879" @click="changeAnswer2()" :class="{ ani1: question }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/q3.png" class="absolute cursor-pointer opacity-0" alt="static" data-wd="459" data-left="9394" data-top="879" @click="changeAnswer3()" :class="{ ani1: question }" />

      <img @click="changeQuestion" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/c1.png" class="absolute cursor-pointer" alt="static" data-wd="328" data-left="8983" data-top="888" :class="{ 'z-index--1': question }" />

      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/a1.png" class="absolute opacity-0" alt="static" data-wd="537" data-left="9269" data-top="141" :class="{ ani1: answer1, 'z-index--1': !answer1 }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/a2.png" class="absolute opacity-0" alt="static" data-wd="537" data-left="9266" data-top="156" :class="{ ani1: answer2, 'z-index--1': !answer2 }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/a3.png" class="absolute opacity-0" alt="static" data-wd="527" data-left="9267" data-top="201" :class="{ ani1: answer3, 'z-index--1': !answer3 }" />

      <img id="talk6" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk6.png" data-active="ani1" data-left-percentage="0.8" class="absolute  opacity-0" alt="static" data-wd="505" data-left="10833" data-top="728" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk7.png" data-active="ani1" data-left-percentage="0.8" class="absolute  opacity-0" alt="static" data-wd="505" data-left="11806" data-top="532" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/fire.png" class="absolute" alt="static" data-wd="1034" data-left="11408" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/play-mp4_2.png" class="absolute cursor-pointer" alt="static" data-wd="302" data-left="11708" data-top="126" @click="showModal('xrba')" />

      <!-- 转场前遮挡 -->
      <img id="brave-before-img" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/before.png" class="before" />
      <img :style="{ 'z-index': showResult ? '-1' : '0' }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/before-btn.png" class="before-btn cursor-pointer" @click="handleShowResult" />

      <img :style="{ 'z-index': showResult ? '-1' : '0' }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/talk10.png" class="absolute before-talk10" />
      <img :style="{ 'z-index': showResult ? '-1' : '0' }" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/brave.gif" class="absolute opacity-0" alt="static" id="brave-talk2" data-left-percentage="0.8" data-active="ani3" data-wd="180" data-left="10680" data-top="216" />

      <div data-alt="speed" class="absolute left-0" data-wd="750" data-left="12875" data-top="136">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/3/pic1.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0" data-wd="518" data-left="14307">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person5.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0" data-wd="442" data-left="14798" data-top="136">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/talk8.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0" data-wd="959" data-left="15317">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person7.png" class="width-100" />
      </div>
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/person6.png" class="absolute" alt="static" data-wd="471" data-left="16736" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/a4.png" class="absolute opacity-0" alt="static" data-wd="537" data-left="17172" data-top="256" :class="{ ani1: answer4, 'z-index--1': !answer4 }" />
      <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/brave/2/q4.png" class="absolute cursor-pointer" alt="static" data-wd="304" data-left="17123" data-top="171" @click="changeAnswer4()" />
    </div>
    <img v-if="showMouseTip" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mouse.png" class="mouse-tip ani-opacity" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// 横向滚动视差滚动对象
let parallax = {
  segment: 15,
  screenWidth: 0,
  dom: null,
  speed: 0.5,
  scrollLeft: 0,
  scrollLeftWithScreen: 0,
  scrollMaxLeft: 0,
  wheelStep: 0,
  minStep: 0,
  curStep: 0,
  longImgWidth: 0,
  longImgRealWidth: 18164,
  longImgRealHeight: 1080,
  imgScale: 1,
  layers: [],
  staticDoms: [],
  music: [],
  extraDom: []
}
let timer
let doingNextMove = false
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showMouseTip: true,
      end: false,
      question: false,
      answer1: false,
      answer2: false,
      answer3: false,
      answer4: false,
      showResult: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleShowResult() {
      const beforeImg = document.getElementById('brave-before-img')
      beforeImg.style.opacity = 0
      setTimeout(() => {
        beforeImg.style.display = 'none'
        this.showMouseTip = true
      }, 1000) // 设置与CSS中的过渡时间一致
      this.showResult = true
    },
    reset() {
      if (this.showMouseTip) return
      this.end = false
      this.showResult = false
      this.question = false
      this.answer1 = false
      this.answer2 = false
      this.answer3 = false
      this.answer4 = false
      this.showMouseTip = true
      const beforeImg = document.getElementById('brave-before-img')
      beforeImg.style.opacity = 1
      beforeImg.style.display = 'block'
      parallax.layers = []
      parallax.staticDoms = []
      parallax.music = []
      parallax.extraDom = []
      parallax.dom.style.transform = `translate3d(0, 0, 0)`
      parallax.scrollLeft = 0
      parallax.curStep = 0
      this.init()
    },
    changeAnswer4() {
      this.answer4 = true
    },
    changeAnswer1() {
      this.answer1 = true
      this.answer2 = false
      this.answer3 = false
    },
    changeAnswer2() {
      this.answer1 = false
      this.answer2 = true
      this.answer3 = false
    },
    changeAnswer3() {
      this.answer1 = false
      this.answer2 = false
      this.answer3 = true
    },
    changeQuestion() {
      this.question = true
    },
    init() {
      this.aniInit()
      this.wheelInit()
    },
    showMp3(mode) {
      let bgImg = ''
      let width = 0
      let height = 0
      let closeRight = 0
      let closTop = 0
      if (mode === 'field-ganyan') {
        bgImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/chen/chen-mp3-1.png'
        width = 501
        height = 675
        closeRight = 30
        closTop = 120
      }
      this.$emit('openMp3Modal', { mode, bgImg, width, height, closeRight, closTop })
    },
    showModal(mode) {
      let backgroundColor = ''
      let titleImg = ''
      let videoUrl = ''
      if (mode === 'cms') {
        backgroundColor = '#f4bc45'
        titleImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/modal-title.png'
        videoUrl = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/brave/cms.mp4'
      } else {
        backgroundColor = '#f4bc45'
        titleImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/modal-title.png'
        videoUrl = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/brave/xrba-2.mp4'
      }
      this.$emit('openModal', { mode, backgroundColor, titleImg, videoUrl })
    },
    aniInit() {},
    wheelInit() {
      // 获取监听滚轮事件
      parallax.dom = document.getElementById('brave')
      // 获取主要滚动dom
      const image = document.getElementById('brave-long-img')
      // console.log('image.width：', image.width)
      parallax.longImgWidth = image.width
      parallax.dom.style.width = image.width + 'px'
      parallax.imgScale = image.width / parallax.longImgRealWidth
      // 获取屏幕宽度
      parallax.screenWidth = window.innerWidth || (document.body && document.body.clientWidth)
      // 最大滚动到左侧距离
      parallax.scrollMaxLeft = parallax.longImgWidth - parallax.screenWidth
      // 每一次距离(屏幕宽度 / 15 * 速率)
      parallax.wheelStep = (parallax.screenWidth / parallax.segment) * parallax.speed
      // 滚动最小距离
      parallax.minStep = parallax.screenWidth / 1000 / parallax.segment
      // 获取滚动到长图的距离 首次进入就是宽度
      parallax.scrollLeftWithScreen = parallax.screenWidth
      // 获取所有要滚动的图片
      this.initChildren()
      console.log('brave-parallax:', parallax)
      // 添加滚轮监听事件
      parallax.dom.addEventListener('wheel', this.handleWheel)
    },
    initPosition(element) {
      const realWidth = element.getAttribute('data-wd')
      const realLeft = element.getAttribute('data-left')
      const realTop = element.getAttribute('data-top')
      if (element.hasAttribute('data-wd')) {
        element.style.width = (realWidth / parallax.longImgRealWidth) * 100 + '%'
      }
      element.style.left = (realLeft / parallax.longImgRealWidth) * 100 + '%'
      if (element.hasAttribute('data-top')) {
        element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
      } else {
        element.style.bottom = 0
      }
    },
    initChildren() {
      // 配置图片
      for (let i = 0; i < parallax.dom.children.length; i++) {
        const element = parallax.dom.children[i]
        if (element.getAttribute('data-alt') === 'speed') {
          // 处理动态
          const speed = element.getAttribute('speed') || 1.1
          const realWidth = element.getAttribute('data-wd')
          const realLeft = element.getAttribute('data-left')
          const realTop = element.getAttribute('data-top')
          let left = realLeft * parallax.imgScale
          left += left / 15
          const layer = {
            dom: element,
            realWidth,
            realLeft,
            speed: Number(speed),
            width: realWidth * parallax.imgScale,
            left: left,
            initLeft: left
          }
          parallax.layers.push(layer)
          // 处理div节点样式
          element.style.width = layer.width + 'px'
          if (element.hasAttribute('data-top')) {
            element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
          } else {
            element.style.bottom = 0
          }
          element.style.transform = `translate3d(${layer.left}px, 0, 0)`
          // 处理内层动画节点样式
          const imgDom = element.children[0]
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          const leftPercentage = element.getAttribute('data-left-percentage') || 0.7
          if (imgDom.classList.contains(activeClass)) {
            imgDom.classList.remove(activeClass)
          }
          parallax.staticDoms.push({
            dom: imgDom,
            activeClass,
            leftPercentage,
            active: false
          })
        } else if (element.alt === 'static') {
          // 处理静态
          this.initPosition(element)
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          if (element.classList.contains(activeClass)) {
            element.classList.remove(activeClass)
          }
          parallax.staticDoms.push({
            dom: element,
            activeClass,
            leftPercentage: element.getAttribute('data-left-percentage') || 0.7,
            active: false
          })
        } else if (element.getAttribute('data-alt') === 'position') {
          this.initPosition(element)
        }
      }
      // 初始化音乐
      const musicContainer = document.getElementById('brave-music-contianer')
      const audioElements = musicContainer.getElementsByTagName('audio')
      for (var i = 0; i < audioElements.length; i++) {
        const element = audioElements[i]
        const imgDom = document.getElementById(element.getAttribute('data-img'))
        const activeClass = imgDom.getAttribute('data-active')
        if (imgDom.classList.contains(activeClass)) {
          imgDom.classList.remove(activeClass)
        }
        parallax.music.push({
          dom: element,
          played: false,
          ended: false,
          imgDom: imgDom,
          endPlayLeft: element.getAttribute('data-end-left') * parallax.imgScale,
          leftPercentage: imgDom.getAttribute('data-left-percentage'),
          activeClass
        })
      }
    },
    listenerAnimation() {
      // 获取所有静态dom
      const { screenWidth } = parallax
      for (let i = 0; i < parallax.staticDoms.length; i++) {
        const item = parallax.staticDoms[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          element.classList.add(item.activeClass)
          item.active = true
        }
      }
      // 获取所有音乐dom
      for (let i = 0; i < parallax.music.length; i++) {
        const item = parallax.music[i]
        const imgDom = item.imgDom
        // 已经结束的就跳过
        if (item.ended) continue
        // 正在播放的需要判断结束位置
        if (item.played) {
          //判断停止位置是否到达
          if (parallax.scrollLeftWithScreen >= item.endPlayLeft) {
            this.$emit('playAudio', item.dom)
            item.ended = true
          }
          continue
        }
        if (imgDom.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          this.$emit('playAudio', item.dom)
          item.played = true
          if (item.activeClass) {
            imgDom.classList.add(item.activeClass)
          }
        }
      }
      // 获取所有特殊的dom
      for (let i = 0; i < parallax.extraDom.length; i++) {
        const item = parallax.extraDom[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          item.active = true
          item.beginAni && item.beginAni()
        }
      }
    },
    handleWheel(event) {
      if (this.showMouseTip) {
        this.showMouseTip = false
      }
      event.preventDefault()
      // 监听动画效果
      this.listenerAnimation()
      // 判断是否前进后退
      const isForward = event.wheelDeltaY < 0
      if (!this.showResult && parallax.scrollLeftWithScreen / parallax.longImgWidth > 0.66) {
        return
      }
      // 根据滚动距离修改当前位置
      parallax.curStep = parallax.curStep + (isForward ? 1 : -1) * parallax.wheelStep
      // 限制移动范围，防止移动超出图片边界
      parallax.curStep = Math.max(0, Math.min(parallax.curStep, parallax.scrollMaxLeft))
      if (!this.end && parallax.curStep === parallax.scrollMaxLeft) {
        this.end = true
        this.$emit('end')
      }
      // console.log(parallax.curStep)
      doingNextMove = true
      timer || (timer = setInterval(() => this.changeScrollLeft(), 17))
    },
    changeScrollLeft() {
      const step = (parallax.curStep - parallax.scrollLeft) / parallax.segment
      // 如果滚动步长的绝对值大于设定的最小步长。
      if (Math.abs(step) > parallax.minStep) {
        parallax.scrollLeft += step
        parallax.scrollLeftWithScreen += step
        parallax.dom.style.transform = `translate3d(${-parallax.scrollLeft}px, 0, 0)`
        // 调整layers
        for (let i = 0; i < parallax.layers.length; i++) {
          const layer = parallax.layers[i]
          if (layer.speed > 0 && layer.speed < 1) {
            layer.left = layer.initLeft + parallax.scrollLeft * (1 - layer.speed)
          } else {
            layer.left = layer.initLeft - parallax.scrollLeft * (layer.speed - 1)
          }
          layer.dom.style.transform = `translate3d(${layer.left}px, 0, 0)`
        }
      } else if (doingNextMove) {
        console.log('doingNextMove')
        // 如果当前滚动步长小于等于最小步长，并且标志表明有下一个移动要进行。
        doingNextMove = false
        clearInterval(timer)
        timer = null
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log('created');
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.wheelInit();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    if (timer) {
      clearInterval(timer)
    }
    parallax.dom.removeEventListener('wheel', this.handleWheel)
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.horwheel-img {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  #brave {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #76c5ff;
  }
  #brave-long-img {
    height: 100%;
  }

  .mouse-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7%;
    transform: translate(-50%, -50%);
  }

  .img-speed-bg {
    position: absolute;
    left: 0;
  }
  .img-static-bg {
    position: absolute;
    opacity: 0;
  }
  .before {
    position: absolute;
    width: 14.38%;
    left: 55.2%;
    top: 0%;
    transition: opacity 1s ease;
  }
  .before-btn {
    position: absolute;
    width: 2%;
    left: 62.1%;
    top: 80%;
    transition: opacity 1s ease;
  }
  .before-talk10 {
    width: 2.642%;
    left: 59%;
    top: 21%;
  }
  .before-talk10-gif {
    width: 0.96%;
    left: 58.721%;
    top: 20%;
  }
  .video-bg {
    position: absolute;
    top: 0;
    height: 100%;
    background: transparent;
    object-fit: fill;
  }
  .video-bg1 {
    left: 12.2%;
    width: 9.48566%;
  }
  .video-bg1-mask {
    position: absolute;
    width: 11.23%;
    left: 11.2%;
    height: 100%;
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Brave/index.vue